import * as perfil from '@/api/perfil'
import { convertSelect } from '../../../service/collection'

const state = {
  list: [],
  listaSelect: {},
  filtros: {page: 1},
  countPage: 0,
  modalAdd: false,
  modalEdit: false,
  modalConfDelPerfil: false
}

const mutations = {
  SETPERFIS (state, payload) {
    state.list = payload.list
  },
  SETPERFISSELECT (state, payload) {
    state.listaSelect = convertSelect(payload.list)
  },
  HIDDEMODAL (state) {
    state.modalAdd = false
    state.modalEdit = false
    state.modalConfDelUnidade = false
  },
  MODALADD (state) {
    state.modalAdd = !state.modalAdd
  },
  MODALEDIT (state) {
    state.modalEdit = !state.modalEdit
  },
  MODALCONFDELPERFIL (state) {
    state.modalConfDelPerfil = !state.modalConfDelPerfil
  },
  SETPAGE (state, payload) {
    state.filtros.page = payload
  },
  SETPAGINATE (state, payload) {
    if (payload === 1) state.countPage = 0
    else state.countPage = payload
  },
  SETFILTROS (state, payload) {
    if (payload) {
      state.filtros = payload
    }
  }
}

const actions = {
  hiddeModal: function ({ commit }) {
    commit('HIDDEMODAL')
  },
  modalAdd: function ({ commit }) {
    commit('MODALADD')
  },
  modalEdit: function ({ commit }) {
    commit('MODALEDIT')
  },
  modalConfDelPerfil: function ({ commit }) {
    commit('MODALCONFDELPERFIL')
  },
  async get ({ commit }, payload) {
    return perfil.get(payload)
  },
  async getPerfis ({ commit }, payload) {
    commit('SETFILTROS', payload)
    let data = await perfil.getPerfisLista(payload)
    commit('SETPERFIS', data)
    commit('SETPAGINATE', data.pages)
  },
  async getPerfisFiltro ({ commit, dispatch }) {
    let data = await perfil.getPerfisLista(state.filtros)
    if (state.filtros.page > data.pages) dispatch('setPage', data.pages)
    else {
      commit('SETPERFIS', data)
      commit('SETPAGINATE', data.pages)
    }
  },
  async getPerfisSelect ({ commit }, payload) {
    let data = await perfil.perfisSelect()
    commit('SETPERFISSELECT', data)
  },
  async add ({ commit }, payload) {
    payload.empresa.id = payload.empresa.value
    return perfil.add(payload)
  },
  async edit ({ commit }, payload) {
    if (payload.empresa) {
      payload.empresa.id = payload.empresa.value
    }
    return perfil.edit(payload)
  },
  async editPerfil ({ commit }, payload) { // altera o perfil do usuario
    return perfil.editPerfil(payload)
  },
  async status ({ commit }, payload) {
    return perfil.edit(payload)
  },
  async delPerfil ({ commit }, payload) {
    try {
      let retorno = await perfil.delPerfil(payload)
      return retorno
    } catch (e) {
      return e
    }
  },
  async addPerfilPadrao ({ commit }, payload) { // adiciona os perfis padroes para a empresa
    try {
      return perfil.addPadrao(payload)
    } catch (e) {
      return e
    }
  },
  async delPerfilPadrao ({ commit }, payload) { // deleta os perfis padroes para a empresa
    try {
      for (let pp = 0; pp < payload.length; pp++) {
        await perfil.delPerfilForcado(payload[pp].id)
      }
      return true
    } catch (e) {
      return e
    }
  },
  setPage (context, payload) {
    context.commit('SETPAGE', payload)
    context.dispatch('getPerfis', state.filtros)
  }
}

export default { namespaced: true, state, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/gerenciador/perfil.js